import { classNames } from 'shared/lib/classNames/classNames'
import cls from '../InstallWidget.module.scss'
import { Button } from 'shared/ui/Button'
import logo from 'shared/assets/MineCards-Logo-Rounded.svg'
import { Cross } from 'shared/ui/Cross'
import { IconBadge, InstallIcon } from 'shared/ui/Icon'

export const AndroidInstall = (props) => {
    const { onDownload, onCloseInstall, cross, text } = props

    return (
        <div className={classNames(cls.InstallWidget, {}, [])}>
            {cross ? <Cross onClose={onCloseInstall} /> : null}
            <div className={cls.ImageContainer}>
                <img className={cls.Image} alt="MineCards" src={logo} />
                <IconBadge className={cls.Icon}>
                    <InstallIcon />
                </IconBadge>
            </div>
            <div className={cls.Text}>{text}</div>
            <Button
                onClick={onDownload}
                className={cls.Button}
                text={'Скачать APK'}
            />
            <div className={cls.SecondText}>
                При установке нажми <b>“Подробнее”</b> а потом{' '}
                <b>”Всё равно установить”</b>
            </div>
        </div>
    )
}
